import { connectCustom } from "@client/lib/misc";
import { getSettingValueSelector, TargetSelector } from "@client/selectors";
import { type AppState, type EntityRef } from "@client/types";
import Component, { type MapProps } from "./component";
import { makeStyleSelector } from "./selectors";

const makeMapStateToProps = () => {
  const navigationTypeSelector = getSettingValueSelector(TargetSelector.Entity, "navigationType");
  const styleSelector = makeStyleSelector();

  return (state: AppState, props: EntityRef): MapProps => {
    return {
      ...props,

      navigationType: navigationTypeSelector(state, props),
      style: styleSelector(state, props)
    };
  };
};
export default connectCustom(makeMapStateToProps)(Component);
